import { InfoSheet } from '@/shared/components/ui/InfoSheet'
import { LeagueFormat, LeagueTransferOption, type League } from '../types'
import { ScoringRulesContent } from './ScoringRulesContent'

type LeagueRulesSheetProps = {
  league:  League
  onClose: () => void
}

// Format-aware: shows only this league's actual format, transfer option and
// tiebreakers, plus the shared scoring preset.
export function LeagueRulesSheet({ league, onClose }: LeagueRulesSheetProps) {
  const isH2H     = league.format === LeagueFormat.HeadToHead
  const isOptionA = league.transferOption === LeagueTransferOption.OptionA

  return (
    <InfoSheet title="Regras da liga" onClose={onClose}>
      <InfoSheet.Section>
        <InfoSheet.SectionTitle>Formato · {isH2H ? 'Head-to-Head' : 'Pontos Gerais'}</InfoSheet.SectionTitle>
        {isH2H ? (
          <InfoSheet.List>
            <InfoSheet.Item>A cada rodada você enfrenta um adversário da liga; quem fizer mais pontos na rodada vence.</InfoSheet.Item>
            <InfoSheet.Item>Vitória vale <b>+3</b> e empate <b>+1</b> para cada um na tabela H2H.</InfoSheet.Item>
            <InfoSheet.Item>Não é possível entrar ou sair da liga depois que a competição começa.</InfoSheet.Item>
            <InfoSheet.Item>Com número ímpar de participantes, um adversário <b>"Média"</b> é criado para você ter sempre com quem jogar (não disputa prêmios).</InfoSheet.Item>
          </InfoSheet.List>
        ) : (
          <InfoSheet.List>
            <InfoSheet.Item>A classificação é pela <b>soma total de pontos</b> acumulada ao longo da competição.</InfoSheet.Item>
            <InfoSheet.Item>Sua equipe só fica visível para os outros depois que a janela de transferências fecha.</InfoSheet.Item>
          </InfoSheet.List>
        )}
      </InfoSheet.Section>

      <InfoSheet.Section>
        <InfoSheet.SectionTitle>Transferências · {isOptionA ? '3 livres por rodada' : 'Ilimitadas'}</InfoSheet.SectionTitle>
        {isOptionA ? (
          <InfoSheet.List>
            <InfoSheet.Item><b>3 transferências livres</b> por rodada; cada extra custa <b>−5 pts</b>.</InfoSheet.Item>
            <InfoSheet.Item>As livres não usadas <b>não acumulam</b> — expiram no fim da rodada.</InfoSheet.Item>
            <InfoSheet.Item>Remover um jogador trazido por transferência paga antes da janela fechar <b>devolve</b> a multa de −5.</InfoSheet.Item>
            <InfoSheet.Item>Na montagem inicial (antes do 1º bloqueio) as transferências são ilimitadas.</InfoSheet.Item>
          </InfoSheet.List>
        ) : (
          <InfoSheet.List>
            <InfoSheet.Item>Transferências <b>ilimitadas</b>, sem custo em pontos.</InfoSheet.Item>
          </InfoSheet.List>
        )}
      </InfoSheet.Section>

      <InfoSheet.Section>
        <InfoSheet.SectionTitle>Critérios de desempate</InfoSheet.SectionTitle>
        {isH2H ? (
          <InfoSheet.List>
            <InfoSheet.Item>1. Mais pontos na tabela H2H (vitórias e empates).</InfoSheet.Item>
            <InfoSheet.Item>2. Mais pontos totais de fantasy acumulados.</InfoSheet.Item>
            <InfoSheet.Item>3. Menos transferências usadas.</InfoSheet.Item>
          </InfoSheet.List>
        ) : (
          <InfoSheet.List>
            <InfoSheet.Item>1. Maior pontuação total acumulada.</InfoSheet.Item>
            <InfoSheet.Item>2. Menos transferências usadas.</InfoSheet.Item>
            <InfoSheet.Item>3. Maior pontuação na rodada mais recente (voltando nas anteriores); por fim, registro mais antigo.</InfoSheet.Item>
          </InfoSheet.List>
        )}
      </InfoSheet.Section>

      <InfoSheet.Section>
        <InfoSheet.SectionTitle>Pontuação · Nossa Preset</InfoSheet.SectionTitle>
        <ScoringRulesContent />
      </InfoSheet.Section>
    </InfoSheet>
  )
}
